module.exports = "https://web-assets.ifttt.com/packs/media/docs/query-ce07d9ba.png";